import { PageFilter } from '../state/app';
import { BlockPrefixListFilter } from '../state/blockPrefix';
import axios from '../utils/axios';

const baseUrl = `/api/blockPrefixes`;

export const fetchBlockPrefixList = async ({
  filters,
  paging,
}: {
  filters: BlockPrefixListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};
